module.exports = __webpack_public_path__ + "static/img/zd05.4b7ad810.svg";